import $ from 'jquery';

$(function () {
  var $sliders = $('.js-slider-range');
  if (!$sliders.length) {
    return;
  }

  var getMin = function (ui) {
    return ui.values[0];
  };
  var getMax = function (ui) {
    return ui.values[1];
  };

  var slideFunction = function (e, ui) {
    var $slider = $(e.target);
    var $first = $('<span>', { class: 'slider-value' });
    var $last = $('<span>', { class: 'slider-value' });
    $first.text(getMin(ui));
    $last.text(getMax(ui));
    $slider.find('> span').first().html($first);
    $slider.find('> span').last().html($last);
  };

  $sliders.each(function () {
    var $slider = $(this);
    var initMin = $slider.data('min');
    var initMax = $slider.data('max');

    $slider.slider({
      range: true,
      min: initMin,
      max: initMax,
      step: 1,
      values: [initMin, initMax],
      slide: slideFunction,
      change: function (_, ui) {
        $slider
          .closest('.js-scalar-filters')
          .find('.js-min-answer')
          .val(getMin(ui));
        $slider
          .closest('.js-scalar-filters')
          .find('.js-max-answer')
          .val(getMax(ui));
        window.StreamObject.asyncPageUpdate();
      },
    });

    slideFunction({ target: $slider }, { values: $slider.slider('values') });
  });
});
